"use client";

import { Box, Button, Text, VStack } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { PlaceholderImage } from "@/_components/ui/PlaceholderImage/PlaceholderImage";

interface ErrorScreenProps {
  onReset: () => void;
}

export function ErrorScreen({ onReset }: ErrorScreenProps) {
  const t = useTranslations("resume_benchmark");

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={4}
    >
      <VStack gap={6} maxW="400px" w="full" textAlign="center">
        <PlaceholderImage
          image="something-went-wrong"
          width="200px"
          height="200px"
          grayscale={false}
        />
        <VStack gap={2}>
          <Text fontSize="xl" fontWeight="bold" color="white">
            {t("error.title")}
          </Text>
          <Text fontSize="sm" color="whiteAlpha.500">
            {t("error.description")}
          </Text>
        </VStack>
        <Button
          onClick={onReset}
          bg="indigo.500"
          color="white"
          borderRadius="xl"
          _hover={{ bg: "indigo.400" }}
        >
          {t("error.tryAgain")}
        </Button>
      </VStack>
    </Box>
  );
}
